import moment from 'moment';
import { EventEmitter } from '../classes';

export class SystemDate extends EventEmitter {
    private static _instance: SystemDate = null;
    private _date: Date;
    private _serverTimeOffset: number;

    public readonly UPDATED = 'updated';

    protected constructor() {
        super();
        this._date = null;
    }

    public static getInstance() {
        return SystemDate._instance || (SystemDate._instance = new SystemDate());
    }

    public static subscribeOnUpdate($scope, cb): void {
        const off = this.getInstance().on(this.getInstance().UPDATED, cb);
        this.getInstance().emit(this.getInstance().UPDATED);

        $scope.$on('$destroy', () => {
            off();
        });
    }

    /**
     * initialize of system date
     * @param dateString https://en.wikipedia.org/wiki/ISO_8601
     */
    public setDate(dateUTCString: string) {
        this._date = new Date(dateUTCString);
        this._serverTimeOffset = Date.now() - this._date.getTime();
        this.emit(this.UPDATED);
        // if (dateString) {
        //     try {
        //         const str = dateString.split(' GMT')[0],
        //             localDate = new Date(),
        //             date = new Date(str);
        //         this._date = date;
        //         this._serverTimeOffset = localDate.getTime() - date.getTime();
        //     } catch (e) {
        //         console.error(e);
        //     }
        // }
    }

    /**
     * get js date object of date
     * @returns {Date|null}
     */
    public getDate() {
        //return this._date || new Date();
        return this._serverTimeOffset ? new Date(new Date().getTime() - this._serverTimeOffset) : new Date();
    }

    /**
     * get momentjs instance of date
     * @returns {*}
     */
    public getMoment() {
        return moment(this.getDate());
    }

    /**
     *
     * @param date https://en.wikipedia.org/wiki/ISO_8601
     * @returns  duration https://momentjs.com/docs/#/durations/
     */
    public getDuration(date) {
        return moment.duration(this.getMoment().diff(date));
    }

    public getStrDateTime(): string {
        return this.getMoment().format('YYYY-MM-DDTHH:mm:ss');
    }

    public getStrDate(): string {
        return this.getMoment().format('YYYY-MM-DD');
    }

    public getStrTime(): string {
        return this.getMoment().format('HH:mm:ss');
    }
}
